import { useEffect, useState } from 'react'
import { LogInSchoolID, HideLoder, ShowLoder } from '../../JS/Common';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import { useContext } from 'react';
import { UserContext } from '../../App';
import { MDBSwitch } from 'mdb-react-ui-kit';
import AlertsComp from '../../Components/AlertsComp';
import { store } from '../../Store/Store';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
function Notification() {
    const { is_enterprise, dcc_module_text } = useConfig();
    const [NotificationData, setNotificationData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const { UserData } = useContext(UserContext);
    const flagForAdminSchool = hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.ONLY_MAIN_ADMIN);
    const stateRedux = store.getState();
    useEffect(() => {
        GetAllNotifications();
    }, []);
    async function GetAllNotifications() {
        var schoolid = LogInSchoolID
        if (flagForAdminSchool) {
            var flag = 1
        } else {
            var flag = 2
        }
        setLoading(true);
        if (schoolid == 0) {
            schoolid = null
        }
        await ApiGetCall(`/settings/notifications/all?schoolId=${schoolid}&flag=${flag}&userId=${stateRedux.authData.csvUserID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setNotificationData(responseRs);
            }
        });
    }

    async function DefaultAdminEmails(eventid, ischeck) {
        var flag = ischeck ? 1 : 2;
        var adminSchoolFlag = stateRedux.authData.SchoolId == 0 ? 1 : 2
        await ApiPostCall(`/settings/notifications/default?schoolId=${LogInSchoolID}&uuid=${eventid}&flag=${flag}&userId=${stateRedux.authData.csvUserID}&eventType=${adminSchoolFlag}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={'Notification successfully updated.'} />);
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                        GetAllNotifications()
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        })
    }
    return (
        <div>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className="row col-12 pe-0 align-items-center">
                <div className="col-md-9"> <h1 className="PageHeading">Notifications</h1>  </div>
            </div>
            {NotificationData?.filter(notification =>
                is_enterprise ? !notification?.events?.includes(dcc_module_text) : notification
            ).map((notification, i) => (
                <div
                    style={{ border: "1px solid #dee2e6", padding: "1rem 1.25rem", color: "#15182191" }}
                    className="w-100 d-flex justify-content-between align-items-center bg-white rounded mb-3"
                >
                    <div className="pe-3">
                        <label style={{ color: "black" }} className="fw-semibold font-15">{notification.events}</label>
                        <br />
                        <label className='pt-2 fw-normal font-13'>{notification.description}</label>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <MDBSwitch
                            className="BgPink cursor-pointer"
                            checked={notification?.selected_flag}
                            title="Notify the administrator?"
                            onChange={(e) => DefaultAdminEmails(notification.id, e.target.checked)}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Notification
